import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoImg from 'eco-design/base/eco-img';

const OnePower: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('OnePower');

    return (
        <div className={`${styles.OnePower} GtmModuleData-section`} data-section-id="OnePower">
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <div className="trail-layout">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1753684245183/pc.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1753684245348/pad.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1753684245688/h5.jpg"
                />
            </div>
            <div className="trail-layout footer-desc">{t('footer_desc')}</div>
        </div>
    );
};

export default OnePower;
